
import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BackPageIcon } from "../../assets/Icon/dashboredIcon";

const BackPageButton = ({ title }: { title?: string }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => title ? navigate("/tools/tax-filing/list") : navigate(-1)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        cursor: "pointer",
        width: "fit-content",
        marginBottom: "20px",
      }}
    >
      <BackPageIcon />
      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "22px",
          letterSpacing: "-0.7%",
          color: "#6C6F71",
        }}
      >
        {title ? title : "Back"}
      </Typography>
    </Box>
  );
};

export default BackPageButton;
